export default __webpack_public_path__ + "static/media/group-color-2.6af73885.jpg";